import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import { AngaraExplanation } from 'src/components/Debug/SearchExplanation/utils';

const searchExplanation = autoGeneratedReducer<AngaraExplanation | null>(null);
export { searchExplanation };
